export type DeviceSettingsType = {
  lastVisitedPage?: string;
  lastSyncDate?: string;
  token?: string;
  // theme?: string;
};

export const DEVICE_SETTINGS_NAME = "device_settings";

export function getData(name: string) {
  const data = localStorage.getItem(name);
  return data ? JSON.parse(data) : {};
}

export function setData(name: string, data: DeviceSettingsType) {
  return localStorage.setItem(name, JSON.stringify(data));
}

export function removeData(name: string) {
  return localStorage.removeItem(name);
}
